import React from "react";
import styled from "styled-components";
import Slider from "react-slick";
import { FormatQuote } from "@mui/icons-material";
import testimonialImage from "../../Assets/frontendImages/testimonial (1).svg"
import ImgAlex from "../../Assets/frontendImages/alex.svg"
import ImgLisa from "../../Assets/frontendImages/lisa chen.svg"
import Imgkaren from "../../Assets/frontendImages/karen.svg"
import Heading from "../UIs/Heading";
import SubHeading from "../UIs/SubHeading";
import HorizontalLine from "../UIs/HorizontalLine";
import Colors from "../../Constants/Colors";

const StyledLovedByIndians = styled.div`
  max-width: 1200px;
  display: flex;
  align-items: center;
  gap: 3rem;
  justify-content: space-between;
  margin: 3rem auto;
  background-color: ${Colors.backgroundGrey};
  border-radius: 1.5rem;
  padding: 3rem 6rem;

  .position-relative {
    position: relative;
    height: 40px;
    margin-top: 1rem;
  }

  .position-relative img {
    position: absolute;
    top: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    background-color: #ddd;
  }

  @media (max-width: 992px) {
    flex-direction: column;
    justify-content: center;
    align-items: center !important;
    align-items: stretch;
    padding: 1.75rem;
    gap: 1.5rem;
  }

  @media (max-width: 576px) {
    padding: 1.25rem;
  }
`;

const StyledReviewCard = styled.div`
  position: relative;
  background-color: #fff;
  border-radius: 1rem;
  padding: 2.5rem 3rem;
  max-width: 35rem;
  width: 100%;
  margin: auto;
  text-align: left;
  transition: transform 0.4s ease;

  .quote-icon {
    color: ${Colors.primary};
    font-size: 40px;
    transform: rotate(180deg);
    margin-bottom: 1rem;
  }

  .title {
    margin-bottom: 0px;
    color: var(--font1);
    font-weight: 600;
  }

  .designation {
    margin: 0px;
    color: var(--font2);
  }

  .d-flex img {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    object-fit: cover;
    background: #eee;
  }
`;

const VerticalSliderWrap = styled.div`
  position: relative;
  width: 100%;
  max-width: 35rem;
  border-radius: 1rem;
  overflow: hidden;

  .slick-slider,
  .slick-list,
  .slick-track {
    overflow: hidden;
    height: auto;
  }

  .slick-slide {
    display: flex !important;
    justify-content: end;
    align-items: center;
  }

  /* 👇 Vertical bar-style pink dots */
  .slick-dots {
    position: absolute;
    top: 50%;
    right: 12px; 
    transform: translateY(-50%);
    list-style: none;
    display: flex !important;
    flex-direction: column;
    align-items: end;
    gap: 8px;
    margin: 0;
    padding: 0;
    height: fit-content;
  }

  .slick-dots li {
    margin: 0;
    padding: 0;
    line-height: 0;
  }

  .slick-dots li button {
    width: 6px;
    height: 20px;
    border-radius: 6px;
    border: none;
    background: rgb(184, 182, 182); 
    text-indent: -9999px;
    padding: 0;
    cursor: pointer;
    transition: all 0.3s ease;
    opacity: 0.5;
  }

  .slick-dots li.slick-active button {
    background: var(--brandColor);
    height: 22px;
    opacity: 1;
  }

  @media (max-width: 992px) {

    .slick-dots {
    top: auto;
    bottom: 2px;
    right: 0;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: row; 
    align-items: center;
    justify-content: center;
  }

  .slick-dots li {
    margin: 0;
    padding: 0;
    line-height: 0;
  }

  .slick-dots li button {
    width: 20px;
    height: 6px;
    border-radius: 6px;
    border: none;
    background: rgb(184, 182, 182); 
    text-indent: -9999px;
    padding: 0;
    cursor: pointer;
    transition: all 0.3s ease;
    opacity: 0.5;
  }

  .slick-dots li.slick-active button {
    background: var(--brandColor);
    width: 22px;
    height: 6px;
    opacity: 1;
  }
  }
`;

const REVIEWS = [
  {
    text: "Zodot’s integrated proposal and contract management features have been a game-changer for me. As a small business owner, I appreciate how everything I need is centralized in one user-friendly platform.",
    author: "Lisa Chen",
    company: "Small Business Owner",
    img: ImgLisa,
  },
  {
    text: "The ability to send agreements via email and get instant notifications when they’re viewed or signed is fantastic. Zodot’s seamless integration into my daily operations has eliminated the hassle of manual follow-ups. ",
    author: "Alex Morgan",
    company: "Freelance Graphic Designer",
    img: ImgAlex,
  },
  {
    text: "As a freelance writer juggling numerous projects, managing tasks and payments used to be a daunting chore. Since discovering Zodot, my workflow has transformed. Now, everything is organized and effortless to manage.",
    author: "Karen W.",
    company: "Freelance Writer",
    img: Imgkaren,
  },
];

// ======== Review Card ========
function ReviewCard({ review }) {
  return (
    <StyledReviewCard>
      <FormatQuote className="quote-icon" />
      <SubHeading className="text-start lh-lg mb-5">{review.text}</SubHeading>
      <HorizontalLine color={Colors.font2} className="my-3" />
      <div className="d-flex align-items-center gap-4">
        <img src={review.img} alt={review.author} />
        <div>
          <p className="title">{review.author}</p>
          <p className="designation">{review.company}</p>
        </div>
      </div>
    </StyledReviewCard>
  );
}

// ======== Main Component ========
function LovedByIndians() {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 700,
    responsive: [
      {
        breakpoint: 568, 
        settings: {
          vertical: false,
          verticalSwiping: false,
          swipeToSlide: true,
        },
      },
    ],
  };

  return (
    <StyledLovedByIndians data-aos="fade-up">
      {/* Left Section */}
      <div>
      <div>
        <Heading className="text-center text-md-start">
        Loved by Freelancers and Teams
        </Heading>

        <div className="text-center text-md-start">
          <img src={testimonialImage} alt="" style={{maxWidth:"150px"}} />
        </div>
      </div>
      </div> 

      {/* Right Section - Vertical Slider */}
      <VerticalSliderWrap>
        <Slider {...sliderSettings}>
          {REVIEWS.map((review, i) => (
            <div key={i}>
              <ReviewCard review={review} />
            </div>
          ))}
        </Slider>
      </VerticalSliderWrap>
    </StyledLovedByIndians>
  );
}

export default LovedByIndians;